import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";

import { BarData } from "../../charts/bar-chart/bar-chart.component";
import { InsightsFieldType } from "../../insights/model/insights-field-type";
import { NODE_TYPE_DATA_TYPE, NodeTypeData } from "../node-types/node-type-data";
import { getInsights, Linqset } from "../../common/linqset-model";

@Component({
    selector: 'app-node-bar-chart',
    templateUrl: './node-bar.html',
    standalone: false
})
export class NodeBarComponent implements OnInit, OnChanges {
    @Input() linqset:Linqset
    @Input() comparison:Linqset

    @Input() trigger:any
    @Input() typeData:NodeTypeData
    @Input() fieldType:InsightsFieldType
    @Input() topNumber:number
    @Input() hideZeros:boolean    

    @Input() width:number
    @Input() height:number

    @Output() selectNodeEvent = new EventEmitter<string>(); 
    
    loading:boolean = false
    data: BarData[];
    xLabel:string
    comparisonName:string
    
    constructor(private changeDetectorRef:ChangeDetectorRef) {

    }

    // the chart's height: room for each bar shown, so names never squash, within sensible bounds
    get chartHeight() {
        const shown = (this.data || []).filter(d => !this.hideZeros || d.getTotalValue() !== 0).length
        const bars = Math.min(this.topNumber || 35, shown)
        return Math.max(220, Math.min(1100, bars * (this.comparisonName ? 34 : 26) + 90))
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["trigger"] || changes["typeData"] || changes["fieldType"]) { 
            this.loading = true
            this.changeDetectorRef.detectChanges()
            setTimeout(() => {
                try {
                    this.populateData()
                } finally {
                    this.loading = false
                }
            }, 0)
        }
    }

    ngOnInit(): void {
        this.populateData()
    }

    clear() {
        this.data = []
    }

    getHeight() {
        return 800
    }

    getStacks() {
        return this.fieldType.getStacks(this.typeData.usesTotals)
    }

    populateData() {
        if (!this.typeData) return

        const colors = this.fieldType.getColours()||[this.typeData.colour]
        const hoverColors = this.fieldType.getHoverColours()||[this.typeData.hoverColour]
        this.comparisonName = undefined

        if (this.typeData.dataType === NODE_TYPE_DATA_TYPE.MODELS) {            
            this.data = this.typeData.models.map(m => {
                const insights = m.insights.find(i => i.projectKey === this.fieldType.workspaceKey)
                const values = this.fieldType.getValueFromInsights(insights, this.typeData.dataType)

                return new BarData(m._key, m.name, values, colors, hoverColors)
            })
        }else if (this.typeData.dataType === NODE_TYPE_DATA_TYPE.GROUP) {            
            this.data = this.typeData.groups.map((nd, i) => {
                const values = this.fieldType.getValueFromInsights(nd.insights, this.typeData.dataType)

                return new BarData(nd._key, nd.name || 'Missing name ' + i, values, colors, hoverColors)
            })
        }else {
            this.comparisonName = this.comparison?.workspaceName
            this.data = this.typeData.list.filter(nd => !nd.excluded).map((nd, i) => {
                const insights = getInsights(nd, this.linqset)
                const comparisonInsights = this.comparison && getInsights(nd, this.comparison)
                
                const values = this.fieldType.getValueFromInsights(insights, this.typeData.dataType)||[0]
                const compare = comparisonInsights && this.fieldType.getValueFromInsights(comparisonInsights, this.typeData.dataType)||[0]

                return new BarData(nd._key, nd.name || 'Missing name ' + i, values, colors, hoverColors, compare,colors, hoverColors)
            })
            if (this.comparison && this.typeData.comparisonList) {
                this.typeData.comparisonList.filter(n => !this.typeData.list.find(n2 => n2._key === n._key)).forEach(n => {
                    const values = [0]
                    const compare = this.fieldType.getComparisonValues(n, this.typeData.dataType)||[0]
    
                    this.data.push(new BarData(n._key, n.name || 'Missing name', values, colors, hoverColors, compare,colors, hoverColors))
                })
            }
        }
        this.xLabel = this.fieldType.getUnits()
    }

    hideChart() {}

    onSelect(event): void {
        this.selectNodeEvent.emit(event)
    }    
}
